import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSetNotification } from '../../../context/Notification';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { UpdateLeadApprovalStatusPayload } from '../types';
import { LEAD_STATE, LEAD_DETAILS } from './constants';

const useUpdateLeadApprovalStatus = (onSuccess?: () => void) => {
    const req = useRequest();
    const queryClient = useQueryClient();
    const setNotification = useSetNotification();

    const request = ({ payload }: { payload: UpdateLeadApprovalStatusPayload }) => {
        return req({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/update-approval-status/`,
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };

    return useMutation({
        mutationFn: request,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [LEAD_STATE, LEAD_DETAILS] });
            setNotification({ message: `Form fill status updated` });
            onSuccess && onSuccess();
        },
        onError: (error: { errors: string[] }) => {
            return error;
        }
    });
};

export default useUpdateLeadApprovalStatus;
